import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { HttpUtilService } from '../config/http-util.service';



@Injectable()
export class ContactService {

	constructor(private _http: Http, private _httpUtil: HttpUtilService) {
    }

	sendMessage(param: any): Observable<any>  {
		let body = JSON.stringify(param);
        return this._http
        .post(this._httpUtil.url('company/sale-form/create'), body)
        .map(res => res.json())
        .catch(err => Observable.throw(err.message));
	}
}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/contact/contact.service.ts